// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDpcQ8nek0F_m7tcB8g4LrAEnzd2vlYjzc",
  authDomain: "oeswebapp-8777b.firebaseapp.com",
  projectId: "oeswebapp-8777b",
  storageBucket: "oeswebapp-8777b.firebasestorage.app",
  messagingSenderId: "883767823886",
  appId: "1:883767823886:web:86cc6e09601c8c759a365f",
  measurementId: "G-4VC684W1J8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, analytics, auth, db };
